import { useState } from "react";
import { useNavigate } from "react-router-dom";

const HOT = ["春分之后", "星河旅馆", "悬疑", "欧美", "动画"];

export default function SearchBand() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const go = (q: string) => {
    const k = q.trim();
    navigate(k ? `/search?q=${encodeURIComponent(k)}` : "/search");
  };

  return (
    <section className="w-full px-4 md:px-8 -mt-10 relative z-20">
      <div className="reveal bg-background-50 border border-background-200 rounded-lg p-4 md:p-6">
        <div className="flex flex-col lg:flex-row lg:items-center gap-4">
          <div className="flex items-center gap-3 shrink-0">
            <span className="w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center text-primary-600">
              <i className="ri-search-eye-line text-2xl"></i>
            </span>
            <div>
              <h2 className="font-heading font-semibold text-foreground-950">找一部想看的电影</h2>
              <p className="text-xs text-foreground-500">输入片名、演员或题材关键词</p>
            </div>
          </div>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              go(keyword);
            }}
            className="flex-1 flex flex-col sm:flex-row gap-2"
          >
            <div className="relative flex-1">
              <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-secondary-400 text-lg"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="例如：爱情、林砚、2024"
                className="w-full h-12 pl-11 pr-3 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200/60 transition"
              />
            </div>
            <button
              type="submit"
              className="h-12 px-7 rounded-md bg-primary-500 text-background-50 text-sm font-label font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              立即搜索
            </button>
          </form>
        </div>
        <div className="mt-4 flex flex-wrap items-center gap-2">
          <span className="text-xs text-foreground-400 font-label">热门搜索：</span>
          {HOT.map((h) => (
            <button
              key={h}
              type="button"
              onClick={() => go(h)}
              className="px-3 py-1 rounded-full bg-background-100 border border-background-200 text-xs text-foreground-600 hover:border-accent-300 hover:text-accent-700 transition-colors cursor-pointer"
            >
              {h}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}